import { normalize } from "polished";
import Styled, { createGlobalStyle } from "styled-components";
import { getRichTextStyle } from "./helpers";

export const GlobalStyle = createGlobalStyle`
  ${normalize()}

  *, *:before, *:after {
    box-sizing: border-box;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    background-color: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.tokens.text.textDefault};
    font-family: ${(props) => props.theme.text.variants.B1.fontFamily};
  }
`;

export const Main = Styled.main`
  padding: 8rem 0 0 0;
`;
